import type { FC, PropsWithChildren } from "react";
import * as s from "./FooterSocials.module.scss";

type FooterSocialsProps = PropsWithChildren<{
	text?: string;
}>;

const FooterSocials: FC<FooterSocialsProps> = ({ text, children }) => {
	return (
		<div className={s.container}>
			<p className={s.text}> {text}</p>
			<div className={s.iconListWrapper}>{children}</div>
		</div>
	);
};
export default FooterSocials;
